<template>
  <div class="upload-content">
    <el-input placeholder="点击并按下CTRL+V" class="paste-input paste-btn" @paste.native="handlePaste"></el-input>
    <FtaUpload v-model="values" ref="upload" v-bind="attrs" v-on="$listeners" @click.native="handleTrackTap" />
    <!-- <voucherPicking
      v-if="sources.length"
      :sources="sources"
      class="v-mt-10"
      :addSoucre="addSoucre"
      :getSources="getSources"
    /> -->
  </div>
</template>
<script>
import FtaUpload from '@meta-vue/cx-uploadfile'
import formMixin from '@meta-vue/vue-ele-form/lib/mixins/formMixin'
import { isEqual, debounce } from 'lodash'
import sourceMixins from './source-mixins'
// import voucherPicking from '@/components/voucher-picking'
// import { getRelativeByAbsolute } from '../voucher-picking/util'

export default {
  name: 'enhancement-cx-upload',
  mixins: [formMixin, sourceMixins],
  components: {
    FtaUpload
    // voucherPicking
  },
  props: {
    value: [Array],
    formItemSchema: {
      type: Object,
      default() {
        return {}
      }
    }
  },
  data: () => {
    return {
      values: []
    }
  },
  computed: {
    limit() {
      return this.attrs?.limit
    }
  },
  watch: {
    value: {
      immediate: true,
      deep: true,
      handler(val) {
        if (Array.isArray(val) && !isEqual(this.values, val)) {
          console.log('组件内数据：', val)
          this.values = [...val]
        }
      }
    },
    values: {
      immediate: true,
      handler(val) {
        if (Array.isArray(val) && !isEqual(this.value, val)) {
          console.log('组件内数据：', val)
          this.$emit('input', [...val])
        }
      }
    }
  },
  methods: {
    mounted() {
      // this.value = []
    },
    handlePaste(e) {
      this.$refs.upload.onPaste2Upload(e)
    },
    addSoucre({ url }) {
      if (!url) return
      if (this.limit && this.values?.length >= this.limit)
        return this.$message.error(`最多只允许上传${this.limit}个，添加失败`)
      // const relativeUrl = getRelativeByAbsolute(url)
      // const exist = this.values?.some?.(val => val?.includes?.(relativeUrl))
      // if (exist) return this.$message.error('该资源已存在，请勿重复上传')
      this.values.push(url)
      this.$message.success('添加成功')
      this.$libTrack.tap?.('Quick_upload_vouchers', 'Voucher_upload', {
        pageName: 'zaixiangongzuotai',
        Session_ID: this?.$route?.query?.callId
      })
    },
    handleTrackTap: debounce(function() {
      this.$libTrack.tap?.('Voucher_upload', 'Voucher_upload', {
        pageName: 'zaixiangongzuotai',
        Session_ID: this?.$route?.query?.callId
      })
    }, 500)
  }
}
</script>

<style lang="stylus" scoped>
.upload-content {
  display: flex;
  flex-direction: column;

  .paste-btn {
    display: inline-block;
    color: #1f5de9;
    cursor: pointer;
    width: 200px;
    font-size: 12px;
    vertical-align: bottom;
    margin-bottom: 5px;
  }
}
</style>
